/** Avoid "Brand Brand …" when the site name already starts with the brand label. */
export function formatServiceCenterName(brandLabel: string | undefined, locationName: string) {
  if (!brandLabel) {
    return locationName;
  }
  if (!locationName) {
    return brandLabel;
  }
  if (locationName === brandLabel || locationName.startsWith(`${brandLabel} `)) {
    return locationName;
  }
  return `${brandLabel} ${locationName}`;
}
